"use client";

import { useState } from "react";

export function OwnerExitButton() {
  const [exiting, setExiting] = useState(false);

  const exit = async () => {
    setExiting(true);
    try {
      await fetch("/api/owner/disable", { method: "POST" });
    } catch {
      // ignore — fall through to reload
    }
    window.location.reload();
  };

  return (
    <button
      type="button"
      onClick={exit}
      disabled={exiting}
      className="rounded-sm border border-white/40 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] transition hover:bg-white hover:text-slate-900 disabled:opacity-60 sm:px-3 sm:tracking-[0.3em]"
    >
      {exiting ? "Exiting…" : "Exit"}
    </button>
  );
}
